/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLocationDirectly: {
  name: 'location-directly';
  data: string;
} = {
  name: 'location-directly',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a1 1 0 0 1 .895.553l8 16a1 1 0 0 1-1.425 1.295L12 16.179l-7.47 4.669a1 1 0 0 1-1.424-1.295l8-16A1 1 0 0 1 12 3ZM6.484 17.268l4.986-3.116a1 1 0 0 1 1.06 0l4.986 3.116L12 6.236 6.484 17.268Z" fill="currentColor"/></svg>`,
};
